import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingAnimationComponent } from './loading-animation.component';
import { AnimationComponent } from "./animation/animation.component";
import { SpinnerSlimComponent } from './spinner-slim/spinner-slim.component';



@NgModule({
  declarations: [
    LoadingAnimationComponent,
    SpinnerSlimComponent
  ],
  imports: [
    CommonModule,AnimationComponent

],
  exports:[
    LoadingAnimationComponent,SpinnerSlimComponent
  ]
})
export class LoadingAnimationModule { }
